import { render, staticRenderFns } from "./GalleryItem.vue?vue&type=template&id=35e8229f&scoped=true&lang=pug"
import script from "./GalleryItem.vue?vue&type=script&lang=js"
export * from "./GalleryItem.vue?vue&type=script&lang=js"
import style0 from "./GalleryItem.vue?vue&type=style&index=0&id=35e8229f&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e8229f",
  null
  
)

export default component.exports